import React from 'react';
import ReactDOM from 'react-dom/client';
// Sem CSS aqui de propósito: o site é HTML estático com /css/site.css (ADR 0085).
// Um CSS importado neste bundle seria injetado depois do site.css e o sobrescreveria.
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
